// src/components/DashboardLayout.js
import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import ComponentsWrapper from "../ComponentsWrapper/ComponentsWrapper";
import "./DashboardLayout.css"; // Add this for custom styles
import Routespage from "../routes/Routespage";
import { useDispatch, useSelector } from "react-redux";
import { fetchCodebookData,fetchCodebookData13 } from "../CodeBook/redux/CodeBookSlicer"; // Adjust the path
import HomePage from "../HomePage/HomePage";


const DashboardLayout = ({ children }) => {
  const [isRowClicked, setIsRowClicked] = useState(false);
  const [sidebarOpen,setSidebarOpen]=useState(false);
  const dispatch = useDispatch();
  const storedPermissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  const isUSA = process.env.REACT_APP_FLAG_USA;

      useEffect(() => {
        if(Object.keys(storedPermissions).includes("Code Accelerate") || Object.keys(storedPermissions).includes("Code Assist")){
          dispatch(fetchCodebookData());
             if (!isUSA) {
            dispatch(fetchCodebookData13());
               }
        }
      }, [dispatch]);
         return (
      <div className="main-wrapper">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div style={{width:'100%'}} className="right-side-section">
          <BreadCrumb sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
          <ComponentsWrapper/>
          <div style={{height:'100%',marginTop:'25px',padding:'7px',width:'100%'}}>
          <Routespage  isRowClicked={isRowClicked} setIsRowClicked={setIsRowClicked}/>
          </div>
          
      </div>
    </div>
  );
};

export default DashboardLayout;
